'use strict'

define ['./settings.css'], () ->
  ($scope, $rootScope, $state, Landlord, Account, $http, RENTAPPLICATION_API_URL) ->
    $scope.mobile_view = window.innerWidth < 768

    $scope.$watch(() ->
      $state.$current.name
    , (newVal, oldVal) ->
      $scope.current_state = $state.$current.name
    )

    $scope.loadMe = () ->
      Landlord.getMe().$promise.then (response) ->
        $scope.landlord = response
        if $scope.landlord.logo
          $scope.filename = $scope.landlord.logo
      Account.getMe({with_stripe_data:true}).$promise.then (response) ->
        $scope.account = response
      $http.get "#{RENTAPPLICATION_API_URL}/api/v1/notification_settings/me/"
        .then (response) ->
          $scope.notification_settings = response.data

    $scope.loadMe()



// WEBPACK FOOTER //
// ./components/dashboard/settings/settings.coffee